module.exports = __webpack_public_path__ + "img/07_3_2_3.c51c0d29.png";